import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_budget_fiscal_period_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_code: fromDatatype.VarcharDatatypeInterface;
  fiscal_period_name: fromDatatype.VarcharDatatypeInterface;
  frequency: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_budget_fiscal_period_RowClass
  implements bl_fi_budget_fiscal_period_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_code: fromDatatype.VarcharDatatypeInterface;
  fiscal_period_name: fromDatatype.VarcharDatatypeInterface;
  frequency: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
